import { combineReducers } from "@reduxjs/toolkit";

// import reducers
import analyticsReducer from "./analytics";
import sizeReducer from "./size";
import sortReducer from "./sort";
import urlReducer from "./url";
import previewReducer from "./preview";
import popup from "./popup";
import modalsReducer from "./modals";
import sliderReducer from "./slider";
import widgetIdReducer from "./widgetId";
import settingsReducer from "./settings";

const rootReducer = combineReducers({
  analytics: analyticsReducer,
  size: sizeReducer,
  sort: sortReducer,
  url: urlReducer,
  preview: previewReducer,
  popup: popup,
  modals: modalsReducer,
  slider: sliderReducer,
  widgetId: widgetIdReducer,
  settings: settingsReducer
});


export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>
